import { useQuery } from "react-query";
import { getDNMData } from "../Requests/getDNMData";

export default function useGetDNMData(params, switchRequest) {
  return useQuery({
    queryKey: ["getDNMData", params],
    queryFn: () => getDNMData(params),
    enabled: switchRequest,
  });
}
